export const AUTH_EVENTS = {
  AUTH_FAILURE: 'HX_AUTH_FAILURE',
  SESSION_LOCK: 'HX_SESSION_LOCK',
  SESSION_RECOVERED: 'HX_SESSION_RECOVERED',
} as const;

export type AuthEventName = (typeof AUTH_EVENTS)[keyof typeof AUTH_EVENTS];
